module.exports = __webpack_public_path__ + "img/truss_design_buttons.c021f18a.jpg";